import React from 'react'
import { HighlightCard } from 'ui/cards'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'
import { useValue } from '@morningtrain/react-resources'
import WhenOrderIsHandled from 'pages/app/inventory/order/partials/WhenOrderIsHandled'
import useFormattedDate from 'support/hooks/formatters/useFormattedDate'
import * as Displays from 'support/displays'

export default function InventoryOrderHandledHighlightCard (props) {
  const handledAtValue = useValue('handled_at')
  const handledAt = useFormattedDate(handledAtValue)
  const handledBy = useValue('handler.name')

  return (
    <WhenOrderIsHandled>
      <HighlightCard
        title={<Translation name='inventory.fragments.handled_box_title' />}
        content={(
          <div className='flex flex-col space-y-1'>
            <UI.Text block>
              <Translation name='inventory.fragments.handled_box_content' data={{ handledAt, handledBy }} />
            </UI.Text>
            <UI.Text block>
              <Displays.Html name='handle_note' />
            </UI.Text>
          </div>
        )}
        color='yellow'
        box={<UI.Icons.ExclamationCircle />}
      />
    </WhenOrderIsHandled>
  )
}
